/**
 * Quote Success Dialog
 * Reusable success dialog for quote cart operations
 */

class QuoteSuccessDialog {
  constructor() {
    this.dialog = null;
  }

  /**
   * Show success dialog with custom message
   * @param {Object} options - Dialog options
   * @param {string} options.title - Dialog title
   * @param {string} options.message - Main message
   * @param {string} options.buttonText - Button text (default: "Continue Shopping")
   * @param {string} options.buttonUrl - Optional URL to navigate to when button is clicked
   * @param {Function} options.onClose - Callback when dialog is closed
   * @param {string} options.type - Dialog type: 'success' or 'error' (default: 'success')
   */
  show({ title = 'Success!', message, buttonText = 'Continue Shopping', buttonUrl = null, onClose = null, type = 'success' }) {
    // Remove existing dialog if any
    this.close();

    // Create dialog element
    this.dialog = document.createElement('dialog');
    this.dialog.className = `quote-success-dialog quote-success-dialog--${type}`;

    this.dialog.innerHTML = `
      <div class="quote-success-dialog__content">
        <button type="button" class="quote-success-dialog__close" aria-label="Close dialog">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <img src="https://savemyserver.com/cdn/shop/files/SaveMyServer.png?v=1727372081&width=400" alt="Save My Server" class="quote-success-dialog__logo">
        <h2 class="quote-success-dialog__title">${title}</h2>
        <p class="quote-success-dialog__message">${message}</p>
        <div class="quote-success-dialog__actions">
          <button type="button" class="button button--primary quote-success-dialog__button">
            ${buttonText}
          </button>
        </div>
      </div>
    `;

    // Add to DOM
    document.body.appendChild(this.dialog);

    // Setup event listeners
    const button = this.dialog.querySelector('.quote-success-dialog__button');
    const closeButton = this.dialog.querySelector('.quote-success-dialog__close');

    const handleMainButtonClick = () => {
      this.close();
      if (buttonUrl) {
        window.location.href = buttonUrl;
      } else if (onClose) {
        onClose();
      }
    };

    const handleCloseButtonClick = () => {
      this.close();
      // X button just closes, no redirect or callback
    };

    button.addEventListener('click', handleMainButtonClick);
    closeButton.addEventListener('click', handleCloseButtonClick);

    // Close on backdrop click (just close, no redirect)
    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) {
        handleCloseButtonClick();
      }
    });

    // Close on escape key (just close, no redirect)
    this.dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        handleCloseButtonClick();
      }
    });

    // Show dialog
    this.dialog.showModal();
  }

  /**
   * Close and remove dialog
   */
  close() {
    if (this.dialog) {
      this.dialog.close();
      this.dialog.remove();
      this.dialog = null;
    }
  }
}

// Create global instance
window.QuoteSuccessDialog = new QuoteSuccessDialog();
